export var ISelectionType;
(function (ISelectionType) {
    ISelectionType[ISelectionType["SINGLE"] = 1] = "SINGLE";
    ISelectionType[ISelectionType["MULTI"] = 2] = "MULTI";
})(ISelectionType || (ISelectionType = {}));
